
import { Component, Vue } from 'vue-property-decorator';
import OsReportsOverview from '@/components/shared/reports/OsReportsOverview.vue';
@Component({
  components: { OsReportsOverview }
})
export default class ReportsIndex extends Vue {}
